// Core
import React from 'react';
import { useSelector } from 'react-redux';

// Components
import { GeckoRow } from 'ui';
import { Chart } from 'react-google-charts';
import graphColours from 'constants/graphColours';
import WidgetTotalHeader from '../../../components/WidgetTotalHeader';
import StatsLoader from 'routes/stats/components/StatsLoader';

const ClosedConversations = (props) => {
  const botsClosedConversations = useSelector(
    (state) => state.statsRoute.botsClosedConversations
  );
  const fetchingStats = useSelector(
    (state) => state.statsRoute.fetchingBotsClosedConversations
  );

  const graphData = [
    ['Category', 'Closed Conversations', { role: 'style' }],
    ['Assigned to Chatbot', botsClosedConversations.bot, graphColours.primary],
    [
      'Assigned to Human',
      botsClosedConversations.human,
      graphColours.secondary,
    ],
  ];

  const graphOptions = {
    hAxis: { 
      textStyle: { fontName: 'Satoshi-Gecko', italic: false, color: '#172554', fontSize: 11, },
      titleTextStyle: { fontName: 'Satoshi-Gecko', italic: false, bold: true, },
      title: '', 
      type: 'text',
      gridlines: {
        color: '#CBD5E1',
      },
      baselineColor: '#CBD5E1',
    },
    vAxis: {
      textStyle: { fontName: 'Satoshi-Gecko', italic: false, color: '#172554', fontSize: 11, },
      titleTextStyle: { fontName: 'Satoshi-Gecko', italic: false, bold: true, color: '#172554' },
      title: 'Conversations',
      format: '#,###',
      minValue: 0,
      maxValue: 5,
      gridlines: {
        color: '#CBD5E1',
        count: -1
      },
      baselineColor: '#CBD5E1',
    },
    legend: 'none',
    tooltip: { isHtml: true },
    focusTarget: 'category',
  };

  return (
    <div>
      <StatsLoader isLoading={fetchingStats}>
        <GeckoRow>
          <div className="col">
            <WidgetTotalHeader
              primary={botsClosedConversations.all}
              suffix={
                <span style={{ fontSize: '14px' }}>
                  {'Total Conversation Closed'}
                </span>
              }
              showSecondary={false}
            />
          </div>
        </GeckoRow>
        <GeckoRow>
          <div className="col">
            <Chart
              chartType="ColumnChart"
              data={graphData}
              options={graphOptions}
              graph_id={props.id}
              width="100%"
              height="400px"
            />
          </div>
        </GeckoRow>
      </StatsLoader>
    </div>
  );
};

export default ClosedConversations;
